import type { CartWarningFragment } from '@shared/types/storefront/graphql'

export const toWarning = (warning: CartWarningFragment) => {
  return {
    code: warning.code,
    message: warning.message,
    target: warning.target,
  }
}
